import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, y: 24, scale: 0.85 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.85 }}
          transition={{ type: "spring", stiffness: 320, damping: 26 }}
          whileHover={{ y: -4 }}
          whileTap={{ scale: 0.9 }}
          onClick={toTop}
          aria-label="Back to top"
          title="Back to top"
          data-testid="back-to-top-button"
          className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full border border-ink/10 bg-white/90 shadow-xl shadow-ink/15 backdrop-blur-xl transition-shadow duration-300 hover:shadow-2xl hover:shadow-brand/25"
        >
          <img src="/logo.webp" alt="EGOS crest" className="h-8 w-8" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
